export const AUTH = {
    LOGIN: '/',
    PASSWORD: '/password',
};

export const APP = {
    HOME: '/home',
    USERS: '/users',
    EXPORTS: '/exports',
    FEEDBACKS: '/feedbacks',
    NOTATIONS: '/notations',
    TOWN_EVENTS: '/town-events',
    USERS_IMAGES: '/users-images',
    VERIFICATIONS: '/verifications',
    BACKOFFICE_USERS: '/backoffice-users',
    MANUAL_ACTIVATION: '/manualActivation',
    OLD_VERIFICATIONS: '/old-verifications',
    PROFILE_NOTATIONS: '/profile-notations',
    PROFILE_REVERIFICATION: '/profile-reverification',
    EXPORTS_BLACKLIST: '/exports-blacklist'
};
